module.exports = __webpack_public_path__ + "img/dfm-new-logo-white.c2eaad9.svg";